import { render } from "./Modal.vue?vue&type=template&id=225836d6&bindings={\"close\":\"setup\"}"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render

export default script